

import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import moment from "moment";
import './styles.css'

export const FormikDataPicker = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  return (
    <div className={props.xmlValuesDisabled ? 'containerDatapicker containerDatapicker--dateDisabled' : 'containerDatapicker'}>
      <div className={props.xmlValuesDisabled ? 'labelDataPicker labelDataPicker--dateDisabled' : 'labelDataPicker'}>
        Fecha
    </div>
      <DatePicker
        {...field}
        {...props}
        dateFormat="dd/MM/yyyy"
        selected={(field.value && new Date(field.value)) || null}
        onChange={val => {
          setFieldValue(field.name, val);
        }}
        placeholderText="DD/MM/YYYY"
        className={props.xmlValuesDisabled ? 'datapicker datapicker--dateDisabled' : 'datapicker'}
      />

    </div>

  );
};

export default FormikDataPicker;